import { connect } from 'react-redux'
import { compose } from 'redux'
import { change as formValueChange } from 'redux-form'
import { withStyles } from '@material-ui/core'

import { AutocompleteBase } from './Autocomplete'

import { styles } from './styles' 

const mapDispatchToProps = {
  formValueChange: formValueChange
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)

export const Autocomplete = enhance(AutocompleteBase)


// WEBPACK FOOTER //
// ./src/components/Autocomplete/index.js